import { chainReducers, INITIAL_API_STATUS } from 'services/api';
import {
  createAddSearchReducer,
  createDeleteSearchReducer,
  createFetchSearchReducer,
  createUpdateSearchReducer,
} from 'services/search';
import { combineReducers } from 'redux';

const initialState = {
  _status: INITIAL_API_STATUS,
  items: [],
};

const fetchSearchReducer = createFetchSearchReducer('picking');
const addSearchReducer = createAddSearchReducer('picking');
const updateSearchReducer = createUpdateSearchReducer('picking');
const deleteSearchReducer = createDeleteSearchReducer('picking');

const searchChainedReducers = chainReducers(
  initialState,
  fetchSearchReducer,
  addSearchReducer,
  updateSearchReducer,
  deleteSearchReducer
);

export default combineReducers({
  searches: searchChainedReducers,
});
